var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",staticStyle:{"z-index":"-1"}},[_c('van-swipe',{attrs:{"autoplay":3000}},_vm._l((_vm.indexData.banner),function(image,index){return _c('van-swipe-item',{key:index},[_c('router-link',{attrs:{"to":image.url || '/'}},[_c('img',{staticClass:"img",attrs:{"alt":image.name,"src":image.pic,"width":"100%"}})])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }